import { useEffect, useState } from 'react';
import type { MiEvento } from '@eventos-cien/shared';
import { useAuth } from '../auth/AuthProvider';
import { apiAuth, ApiError } from '../lib/apiAuth';

/**
 * GET /api/mis-eventos: eventos donde el usuario en sesion tiene membresia
 * activa. Una sesion de staff sin cuenta (login por codigo) no tiene doc
 * usuarios/{uid} — esa ruta le daria 403 — asi que se resuelve directo
 * desde los claims del token, sin llamar a la API.
 */
export function useMisEventos() {
  const { staffEventoId } = useAuth();
  const [eventos, setEventos] = useState<MiEvento[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (staffEventoId) {
      setEventos([
        { eventoId: staffEventoId, nombre: '', tema: { primario: null, secundario: null, terciario: null }, roles: ['staff'] },
      ]);
      return;
    }

    let vivo = true;
    apiAuth<MiEvento[]>('/mis-eventos')
      .then((r) => vivo && setEventos(r))
      .catch((err) => {
        if (!vivo) return;
        setError(err instanceof ApiError ? err.message : 'No se pudieron cargar tus eventos');
      });
    return () => {
      vivo = false;
    };
  }, [staffEventoId]);

  return { eventos, error };
}
